export let errorMessage;
export let validationStatus;


const validation = target => {
  errorMessage = {};
  validationStatus = true;
  let pwdChk = [];
  let emailChk = [];
  let ansChk = [];
  let passwordFieldCount = 0;
  let emailFieldCount = 0;

  
  for (let i = 0; i < target.length; i++) {
    if (!target[i].disabled) {
      if (target[i].name.toLowerCase().includes("password")) {
        passwordFieldCount++;
      }
      if (target[i].name.toLowerCase().includes("email")) {
        emailFieldCount++;
      }
    }
  }

  for (let i = 0; i < target.length; i++) {
    if (target[i].tagName !== "BUTTON" && !target[i].disabled && target[i].name !== "hidden_input") {
      /* Condition to check if field is empty/blank */

      if (target[i].value === "" && target[i].tagName !== "SELECT") {        
        errorMessage[target[i].name] = "BLANK";
        validationStatus = false;
      }

      /* Text box validation other than email, password and phone number */

      if (
        typeof target[i].value !== "undefined" &&
        target[i].type === "text" &&
        !target[i].name.toLowerCase().includes("email") &&
        !target[i].name.toLowerCase().includes("number") &&
        !target[i].name.toLowerCase().includes("count") &&
        !target[i].name.toLowerCase().includes("total") &&
        !target[i].name.toLowerCase().includes("zip") &&
        !target[i].name.toLowerCase().includes("comment") &&
        target[i].name !== "email" &&
        !target[i].name.toLowerCase().includes("address") &&
        !target[i].name.toLowerCase().includes("agency") &&
        !target[i].name.toLowerCase().includes("businessname") &&
        !target[i].name.toLowerCase().includes("phone") &&
        !target[i].name.toLowerCase().includes("login") &&
        target[i].tagName === "INPUT"
      ) {
        if (!target[i].value.match(/^[a-zA-Z ]*$/)) {          
          errorMessage[target[i].name] = "ALPHA";

          validationStatus = false;
        }
      }

      /* Number validation*/

      if (
        typeof target[i].value !== "undefined" &&
        target[i].type === "text" &&
        (target[i].name.toLowerCase().includes("count") ||
         target[i].name.toLowerCase().includes("total")) &&
        target[i].tagName === "INPUT" &&
        target[i].value !== ""
      ) {
        if (isNaN(target[i].value)) {
          
          errorMessage[target[i].name] = "VALIDNUMBER";
          validationStatus = false;
        }
      }

      /* Zipcode validation */

      if (
        typeof target[i].value !== "undefined" &&
        target[i].type === "text" &&
        (target[i].name.toLowerCase().includes("postal") ||
          target[i].name.toLowerCase().includes("zip")) &&
        target[i].tagName === "INPUT" &&
        target[i].value !== ""
      ) {
        
        var pattern = new RegExp(/^[0-9]{5}(?:-[0-9]{4})?$/);

        if (!pattern.test(target[i].value)) {
          
          errorMessage[target[i].name] = "ZIPCODE";
          validationStatus = false;
        }
      }

      /* Phone number validation */

      if (
        typeof target[i].value !== "undefined" &&
        target[i].type === "text" &&
        (target[i].name.toLowerCase().includes("number") ||
          target[i].name.toLowerCase().includes("phone")) &&
        target[i].tagName === "INPUT"
      ) {
        if (target[i].value !== "" && !target[i].value.match(/^[0-9]{10}$/)) {
         
          errorMessage[target[i].name] = "PHONENUMBER";
          validationStatus = false;
        }
      }

      /* Email validation */

      if (
        typeof target[i].value !== "undefined" &&
        target[i].type === "text" &&
        target[i].name.toLowerCase().includes("email") &&
        target[i].tagName === "INPUT"
      ) {
        
        var pattern = new RegExp(
          /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );
        emailChk.push(i);
        if (target[i].value !== "" && !pattern.test(target[i].value)) {
          
          errorMessage[target[i].name] = "EMAIL";
          validationStatus = false;
        } else if (
          emailChk.length === 2 &&
          emailFieldCount === 2 &&
          pattern.test(target[emailChk[0]].value) &&
          pattern.test(target[emailChk[1]].value)
        ) {
          if (
            target[emailChk[0]].value.localeCompare(
              target[emailChk[1]].value
            ) !== 0
          ) {
           
            errorMessage[target[emailChk[0]].name] = "EMAILNOMATCH";
            errorMessage[target[emailChk[1]].name] = "EMAILNOMATCH";

            validationStatus = false;
          }
        } else if (
          emailChk.length === 3 &&
          emailFieldCount === 3 &&
          pattern.test(target[emailChk[1]].value) &&
          pattern.test(target[emailChk[2]].value)
        ) {
          if (emailChk.length > 2) {
            if (
              target[emailChk[1]].value.localeCompare(
                target[emailChk[2]].value
              ) !== 0
            ) {
              
              errorMessage[target[emailChk[1]].name] = "EMAILNOMATCH";
              errorMessage[target[emailChk[2]].name] = "EMAILNOMATCH";
              validationStatus = false;
            }
          }
        }
      }

      /* Drop down list validation */

      if (
        target[i].tagName === "SELECT" &&
        target[i].options[target[i].selectedIndex].text
          .toLowerCase()
          .includes("select")
      ) {
        
        errorMessage[target[i].name] = "DROPDOWNLIST";
        validationStatus = false;
      }

      if (
        typeof target[i].value !== "undefined" &&
        target[i].name.toLowerCase().includes("answer") &&
        target[i].tagName === "INPUT"
      ) {
        ansChk.push(i);

        if (
          ansChk.length === 2 &&
          target[ansChk[0]].value.localeCompare(target[ansChk[1]].value) !==
            0 &&
          target[ansChk[0]].value !== "" &&
          target[ansChk[1]].value !== "" &&
          target[ansChk[0]].value.match(/^[a-zA-Z ]*$/) &&
          target[ansChk[1]].value.match(/^[a-zA-Z ]*$/)
        ) {
          

          errorMessage[target[ansChk[0]].name] = "SECURITYANSWER";
          errorMessage[target[ansChk[1]].name] = "SECURITYANSWER";
          validationStatus = false;
        }
      }

      /* Password validation */

      if (
        typeof target[i].value !== "undefined" &&
        target[i].type === "password" &&
        target[i].tagName === "INPUT" &&
        !target[i].name.toLowerCase().includes("login")
      ) {
        pwdChk.push(i);
         
        if (
          target[i].value !== "" &&
          !target[i].value.match(
            /^.*(?=.{8,12})(?=.*\d)(?=.*[a-z])(?=.*[!@#$%&*()]).*$/
          ) &&
          !target[i].name.toLowerCase().includes("oldpassword") &&
          !target[i].name.toLowerCase().includes("confirm")

        ) {
          
           errorMessage[target[i].name] = "SECUREPASSWORD";
          validationStatus = false;
        } else if (
          pwdChk.length === 2 &&
          passwordFieldCount === 2 &&
          target[pwdChk[0]].value.match(
            /^.*(?=.{8,12})(?=.*\d)(?=.*[a-z])(?=.*[!@#$%&*()]).*$/
          ) &&
          
          !target[i].name.toLowerCase().includes("oldpassword") &&
          target[i].value !== ""
        ) {
          if (
            target[pwdChk[0]].value.localeCompare(target[pwdChk[1]].value) !== 0
          ) {
            
            errorMessage[target[pwdChk[0]].name] = "PASSWORDNOMATCH";
            errorMessage[target[pwdChk[1]].name] = "PASSWORDNOMATCH";
            validationStatus = false;
          }
        } else if (
          pwdChk.length === 3 &&
          passwordFieldCount === 3 &&
          target[pwdChk[1]].value.match(
            /^.*(?=.{8,12})(?=.*\d)(?=.*[a-z])(?=.*[!@#$%&*()]).*$/
          ) &&
          
          !target[i].name.toLowerCase().includes("oldpassword") &&
          target[i].value !== ""
        ) {
          if (pwdChk.length > 2) {
            if (
              target[pwdChk[1]].value.localeCompare(target[pwdChk[2]].value) !==
              0
            ) {
              
              errorMessage[target[pwdChk[1]].name] = "PASSWORDNOMATCH";
              errorMessage[target[pwdChk[2]].name] = "PASSWORDNOMATCH";
              validationStatus = false;              
            }
          }
        }
      }

      /* Check box validation */

      if (
        target[i].type === "checkbox" &&
        target[i].tagName === "INPUT" &&
        !target[i].checked
      ) {
                errorMessage[target[i].name] = "CHECKBOX";
        validationStatus = false;
      }
    }
  }  
  return validationStatus;
};

export default validation;



// WEBPACK FOOTER //
// ./src/utils/validation.js